import { createUrl, restPost } from '~/src/dash/api/rest';
import { Order } from '~/src/dash/components/tables/ListViewTable/common';
import { IInventoryRule } from '~/src/dash/apiV2/inventory-rules/inventoryRules';

export interface IContentMetadataQueryParams {
  Search?: string;
  Page: number;
  PageSize: number;
  OrderBy: string;
  OrderDirection: Order;
  ContentTitle?: string[];
  ContentGenre?: string[];
  ContentNetwork?: string[];
  ContentCategory?: string[];
}

export interface IGetContentMetadataData {
  InvRuleContentData: IContentMetadata[];
  TotalCount: number;
}

export async function getContentMetadataData(
  publisherID: string,
  query: IContentMetadataQueryParams,
  signal?: AbortSignal,
): Promise<IGetContentMetadataData> {
  const reqUrl = `${createUrl('/inv_rule_content_data/search', publisherID, 'v1')}`;
  const response = await restPost<unknown>(reqUrl, query, undefined, undefined, signal);
  return (
    (response?.parsedBody as IGetContentMetadataData) || {
      InvRuleContentData: [],
      TotalCount: 0,
    }
  );
}

export interface IContentMetadata {
  ID: number;
  Name: string;
  ContentID: string;
  ContentCategory: string;
  ContentChannel: string;
  ContentContext: string;
  ContentDistributionID: string;
  ContentDistributionName: string;
  ContentEpisode: string;
  ContentGenre: string;
  ContentKeywords: string;
  ContentLanguage: string;
  ContentLength: number;
  ContentNetwork: string;
  ContentProdQuality: string;
  ContentProducerID: string;
  ContentProducer: string;
  ContentRating: string;
  ContentSeason: string;
  ContentSeries: string;
  ContentTaxonomy: string;
  ContentTitle: string;
  ContentURL: string;
  AssociatedInventoryRules: number;
  InventoryRules: IInventoryRule[] | null;
}
